// extracted by mini-css-extract-plugin
module.exports = {"body":"tableStyles_body__PmKdL"};